import { thumbnail } from "@cloudinary/url-gen/actions/resize";
import { Cloudinary } from "@cloudinary/url-gen/index";
import { focusOn } from "@cloudinary/url-gen/qualifiers/gravity";

const url = `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUDNAME}/image/upload`;

export const uploadImageToCloudinaryAndTransformImge = async (imageFormData) => {
    imageFormData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
    try {
        const response = await fetch(url, {
            method: 'POST',
            body: imageFormData,
        });
        const data = await response.json();
        return transformImage(data.secure_url);
    } catch (error) {
        console.error('Error uploading image to Cloudinary:', error);
    }
};

const transformImage = (imageUrl) => {
    const cld = new Cloudinary({
        cloud: {
            cloudName: process.env.REACT_APP_CLOUDINARY_CLOUDNAME,
        },
    });

    const myImage = cld.image(imageUrl.slice(imageUrl.indexOf('upload/') + 7)).resize(thumbnail().width(parseInt(process.env.REACT_APP_CLOUDINARY_CROP_WIDTH)).height(parseInt(process.env.REACT_APP_CLOUDINARY_CROP_HEIGHT)).gravity(focusOn('face'))).format('png');
    return myImage.toURL();
};